import { SET_MAP_BOUNDS } from './types';

export const setBounds = bounds => {
    return { type: SET_MAP_BOUNDS, payload: bounds }
};